import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import ErrorBoundary from 'components/Sentry/ErrorBoundary';
import { signInSuccess } from 'features/user/state/User.action';
import { useAuth0 } from '@auth0/auth0-react';
import { clearRemotePool } from 'util/storage/pouchdb';

const COUCHDB_CLAIM = 'https://moneytracker.app/couchDB';

const WithUserInfo = ({ children, dispatch }) => {
  const { isLoading, isAuthenticated, error, user } = useAuth0();

  useEffect(() => {
    if (isAuthenticated && dispatch) {
      const couchDB =
        user?.[COUCHDB_CLAIM] ?? user?.couchDB ?? user?.app_metadata?.couchDB ?? null;
      const userInfo = { couchDB };
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      if (couchDB) clearRemotePool();
      dispatch(signInSuccess());
    }
  }, [isAuthenticated, user, dispatch]);

  if (isLoading) {
    return <div>Loading user info...</div>;
  }
  if (error) {
    return (
      <div>
        <h1>Auth Error:</h1>
        {error}
      </div>
    );
  }

  return children;
};

const authDomain = process.env.REACT_APP_AUTH_DOMAIN;
const authClientId = process.env.REACT_APP_AUTH_CLIENT_ID;
const authRedirect = process.env.REACT_APP_AUTH_REDIRECT || window.location.origin;

// Do NOT redirect here — the SDK must read code/hash from the URL first.
// AuthCallbackPage (route /auth) redirects to / once isAuthenticated is true.
const onRedirectCallback = () => {};

const Root = ({ store, history }) => (
  <ErrorBoundary>
    <Auth0Provider
      domain={authDomain}
      clientId={authClientId}
      authorizationParams={{
        redirect_uri: authRedirect
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      <Provider store={store}>
        <WithUserInfo dispatch={store.dispatch}>
          <App history={history} />
        </WithUserInfo>
      </Provider>
    </Auth0Provider>
  </ErrorBoundary>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default Root;
